import { NA } from '../../../utilities/format';

/** Rows per page the Affiliate Marketing tables offer — live's pager's sizes. */
export const PAGE_SIZE_OPTIONS = [10, 25, 50];
export const SEARCH_DELAY = 300;

const DATE = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
const TIME = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

const toDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "16 Oct 2026" — anything unparseable is shown as sent rather than hidden. */
export const formatDate = (value) => {
  const d = toDate(value);
  return d ? DATE.format(d) : value ? String(value) : NA;
};

/** "16 Oct 2026, 14:05" — the commission and code tables carry the time too. */
export const formatDateTime = (value) => {
  const d = toDate(value);
  return d ? `${DATE.format(d)}, ${TIME.format(d)}` : value ? String(value) : NA;
};

/** "10%" / "12.50%" — `decimals` only where live fixed them (commission payouts). */
export const percent = (value, decimals) => {
  if (value === null || value === undefined || value === '') return NA;
  const n = Number(value);
  if (Number.isNaN(n)) return NA;
  return `${decimals != null ? n.toFixed(decimals) : n}%`;
};

/** The sign-up link a commission's code points at, as live builds it. */
export const signupUrl = (code) => `https://app.alphacapitalgroup.uk/signup/${code}/`;

/**
 * The live API's long-form UK name, shortened the way live shows it, so it
 * fits a table cell and a chart legend.
 */
export const countryLabel = (name) =>
  name ? String(name).replace('United Kingdom of Great Britain and Northern Ireland', 'United Kingdom') : NA;
